<script lang="ts" module>
  import type { ColorVariant } from '@agapi/ui/types';

  export interface NavBarProps {
    searchResults?: any[];
    searchSuggestions?: string[];
    navData?: NavData;
    colorVariant?: ColorVariant;
  }
</script>

<script lang="ts">
  import { Navbar, NavbarSkip } from '@agapi/ui/navbar';
  import { css } from '@agapi/ui/panda/css';

  import type { NavData } from '../../types/navData';
  import * as CustomNavbar from './_components';

  const { navData, colorVariant = 'primary.contrast' }: NavBarProps = $props();

  const navBarRootStyles = css.raw({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    md: { mb: 'unset' }
  });
  const navBarUnderHeaderStyles = css.raw({
    order: -1,
    p: 'none',
    m: 'none',
    zIndex: '9!',
    md: { order: 0 }
  });
</script>

<Navbar id="navbar-root" {colorVariant} css={navBarRootStyles} underHeaderStyles={navBarUnderHeaderStyles}>
  <NavbarSkip href="#main-content" label="Skip to main content" />

  <!-- Navbar Header Top -->
  <CustomNavbar.HeaderTop {navData} />

  <!-- Navbar Header Bottom -->
  <CustomNavbar.HeaderBottom {navData} />

  <!-- Mega Menu (Left, Right) -->
  <CustomNavbar.Megamenu {navData} />

  <!-- Slot: Alert Banners -->
  {#snippet underHeader()}
    <CustomNavbar.AlertBanner banners={navData?.banners ?? []} />
  {/snippet}

  <!-- Slot: Meny Drawer -->
  {#snippet menu()}<CustomNavbar.Menu {navData} />{/snippet}

  <!-- Slot: Minicart Drawer -->
  {#snippet drawer()}<CustomNavbar.Cart />{/snippet}
</Navbar>
